import Drawer from '@material-ui/core/Drawer';
import React from 'react';

import {
  INITIAL_DRAWER_WIDTH,
  INLINE_WORKSPACE_DRAWER_DURATION,
} from './constants';

export const FloatingWorkspaceDrawer = ({
  isDrawerOpen,
  closeWorkspaceDrawer,
  children,
}: {
  isDrawerOpen: boolean;
  closeWorkspaceDrawer: () => void;
  children: React.ReactNode;
}) => {
  return (
    <Drawer
      hideBackdrop
      anchor="right"
      open={isDrawerOpen}
      onClose={closeWorkspaceDrawer}
      variant="persistent" // renders drawer asChild
      transitionDuration={INLINE_WORKSPACE_DRAWER_DURATION} // for consistency, make sure this matches inline drawer duration
      PaperProps={{
        style: {
          position: 'absolute',
          top: '57px', // account for the named workspace view bar
          height: 'calc(100% - 57px)',
          boxShadow: ' 0px 12px 24px 0px rgba(21, 24, 31, 0.16)',
          width: INITIAL_DRAWER_WIDTH,
        },
      }}>
      {children}
    </Drawer>
  );
};
